import React from 'react'
import { FaLinkedin, FaFacebook, FaInstagram } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { SERVICES, SERVICES_HUB, serviceHref } from '../data/services.js'

const companyLinks = [
  { label: 'Our Work', to: '/portfolio' },
  { label: 'Industries', to: '/industries' },
  { label: 'Insights', to: '/blog' },
  { label: 'About', to: '/about' },
  { label: 'Contact', to: '/contact' },
]

const resourceLinks = [
  { label: 'Why Websites', to: '/whywebsites' },
  { label: 'Website Health Check', to: '/website-health-check' },
]

const linkClass = 'text-blue-100 hover:text-white transition'

function FooterColumn({ title, children }) {
  return (
    <div>
      <h2 className="text-sm font-semibold mb-4 uppercase tracking-wide text-brand-sky">
        {title}
      </h2>
      <ul className="space-y-2.5 text-sm">{children}</ul>
    </div>
  )
}

export default function Footer() {
  return (
    <footer className="bg-brand-navy text-white pt-14 pb-10 px-4">
      <div className="max-w-6xl mx-auto grid gap-10 sm:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">

        {/* Brand + Local Signal */}
        <div>
          <p className="text-lg font-semibold mb-3">2merative</p>
          <p className="text-sm text-blue-100 mb-3 max-w-xs leading-relaxed">
            Digital growth for established businesses. Premium websites, SEO &amp; GEO, Google
            Ads, AI chatbots and connected business solutions.
          </p>
          <p className="text-sm text-brand-sky">
            Adelaide, South Australia
          </p>

          <div className="flex items-center gap-4 text-xl mt-6">
            <a
              href="https://www.linkedin.com/company/2merative"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="hover:text-brand-sky transition"
            >
              <FaLinkedin />
            </a>
            <a
              href="https://www.facebook.com/share/188qhAZZwo/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="hover:text-brand-sky transition"
            >
              <FaFacebook />
            </a>
            <a
              href="https://www.instagram.com/2merative"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="hover:text-brand-sky transition"
            >
              <FaInstagram />
            </a>
          </div>
        </div>

        <FooterColumn title="Services">
          {SERVICES.map((service) => (
            <li key={service.key}>
              <Link to={serviceHref(service)} className={linkClass}>
                {service.navLabel}
              </Link>
            </li>
          ))}
          <li>
            <Link to={SERVICES_HUB} className={linkClass}>
              All services
            </Link>
          </li>
        </FooterColumn>

        <FooterColumn title="Company">
          {companyLinks.map((link) => (
            <li key={link.to}>
              <Link to={link.to} className={linkClass}>
                {link.label}
              </Link>
            </li>
          ))}
        </FooterColumn>

        <FooterColumn title="Resources">
          {resourceLinks.map((link) => (
            <li key={link.to}>
              <Link to={link.to} className={linkClass}>
                {link.label}
              </Link>
            </li>
          ))}
        </FooterColumn>
      </div>

      <div className="max-w-6xl mx-auto mt-12 pt-6 border-t border-white/15 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-brand-sky">
        <p>
          © {new Date().getFullYear()} 2merative
        </p>

        <Link
          to="/terms"
          className="underline hover:text-white transition"
        >
          Terms & Conditions
        </Link>
      </div>
    </footer>
  )
}
